// material-ui
import { Box, Typography } from '@mui/material';

// messages
import { footerText } from '@/messages';

export default function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '4px',
        alignItems: 'center',
        textAlign: 'center',
        position: 'relative',
        marginTop: {xs: '16px', md: '24px'},                
        paddingTop: '16px',
        paddingBottom: '8px',
        height: '3em',
          '&::before, &::after': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0
        },
        '&::before': {
          height: 3,
          bgcolor: 'rgd.primary'
        },
        '&::after': {
          height: 3,
          mt: '6px',
          bgcolor: 'rgd.primary'
        },
      }}
    >
      <Typography
        variant="h5"
        sx={{ 
          fontSize: {xs: '0.9rem', md: '1rem'},
          fontWeight: '400', 
          color: 'rgd.text1'
        }}
      >
        {footerText.highlighted}
        <Typography
          component="span"
          sx={{ 
            fontSize: {xs: '0.9rem', md: '1rem'},
            fontWeight: '400', 
            color: 'rgd.text2'
          }}
        >
          {footerText.msg1}
        </Typography>
      </Typography>

      <Typography 
        variant="span"
        sx={{
          fontSize: {xs: '0.9rem', md: '1rem'},
          fontWeight: '400', 
          color: "rgd.text2"
        }}
      >
        {footerText.msg2}
      </Typography>
    </Box>
  );
}